import * as React from 'react';

import { Radio } from '@cian/ui-kit';
import { YearTooltip } from './YearTooltip';

import * as styles from './Year.css';

interface IYearProps {
  year: number;
  checked: boolean;
  nextAvailableYear: number | null;
  onChange: (value: number) => void;
  isFullscreen: boolean;
}

export const Year: React.VFC<IYearProps> = ({ year, onChange, checked, nextAvailableYear, isFullscreen }) => {
  const radioRef = React.useRef<HTMLDivElement | null>(null);
  const [open, setOpen] = React.useState(false);

  const handleChange = React.useCallback(() => {
    setOpen(false);
    onChange(year);
  }, [onChange, year]);

  const handleButtonClick = React.useCallback(() => {
    setOpen(false);
    onChange(nextAvailableYear as number);
  }, [onChange, nextAvailableYear]);

  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, [onChange]);

  React.useEffect(() => {
    setOpen(nextAvailableYear === year);
  }, [nextAvailableYear]);

  return (
    <React.Fragment key={year}>
      <div ref={radioRef} className={styles['year-wrapper']}>
        <Radio name={String(year)} label={year} value={String(year)} checked={checked} onChange={handleChange} />
        {open && (
          <YearTooltip
            onClose={handleClose}
            isFullscreen={isFullscreen}
            content={
              <div className={styles['content']}>
                Есть изменения в {nextAvailableYear} г.
                <button className={styles['button']} onClick={handleButtonClick}>
                  Посмотреть
                </button>
              </div>
            }
          />
        )}
      </div>
    </React.Fragment>
  );
};
